/* eslint-disable no-console */
import axios from 'axios';

import {STRATEGY_BASE_URL} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useUserStore from '../../../store/userStore/userStore';

const getUserGroups = async (type: string): Promise<any> => {
  try {
    const token = useUserStore.getState().userToken;
    const response = await axios.request({
      method: CRUDMethods.GET,
      url: `${STRATEGY_BASE_URL}/stakeholdergroup?type=${type}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {},
      data: {}
    });

    return response.data.data;
  } catch (err: any) {
    return [];
  }
};

export default getUserGroups;
